import React, { Fragment, Component } from "react";

import { AssessmentQuestionTypeEnum } from "@/core/constants";
import Button from "@/components/UI/Button";
import { captureErrorMessage, parseError } from "@/lib/helpers/captureErrorMessage";
import { COMPLETED_STEP, START_STEP } from "@/components/Screening/A5Screening";
import images from "@/utils/images";
import { QuestionV2 } from "@/components/Patient/Assessment";
import { workflowRequests } from "@/api/(requests)/workflow";

class AssessmentInProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assessmentDetails: this.props.assessmentDetails,
      completionPercentage: this.props.completionPercentage,
      currentQuestion: this.props.currentQuestion,
      isLastQuestion: this.props.isLastQuestion,
      lastSelectedOption: this.props.lastSelectedOption,
      selectedOptionFull: this.props.selectedOptionFull ? this.props.selectedOptionFull : [],
      selectedOptions: this.props.selectedOptions ? this.props.selectedOptions : [],
    };
  }

  workflowState =
    this.props.sharedWorkflowData &&
    this.props.sharedWorkflowData.workflow_instance &&
    this.props.sharedWorkflowData.workflow_instance.state;

  componentDidMount() {
    this.getQuestion({
      assessment_type: this.workflowState.assessment_type,
      entity_id: this.props.sharedWorkflowData.workflow_instance.entity_id,
      entity_type: "workflow",
    });
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.isLastQuestion && !this.state.currentQuestion) {
      this.props.nextStepHandler(COMPLETED_STEP);
    }
  }

  handleNextQuestion = (singleChoiceOption = null) => {
    const options = singleChoiceOption
      ? [singleChoiceOption]
      : this.state.currentQuestion.options.filter((el) => {
          return this.state.selectedOptions.find((index) => index === el.index) !== undefined;
        });
    let requestBody = {
      assessment_type: this.workflowState.assessment_type,
      entity_type: "workflow",
      id: this.state.assessmentDetails.id,
      options: options,
      question_id: this.state.currentQuestion.question_id,
    };

    this.submitQuestion({
      ...requestBody,
      entity_id: this.props.sharedWorkflowData.workflow_instance.entity_id,
    });
  };

  handlePrevQuestion = () => {
    if (this.state.completionPercentage === 0) {
      this.props.prevStepHandler(START_STEP);
    } else {
      this.getPrevQuestion({
        assessment_type: this.workflowState.assessment_type,
        entity_id: this.props.sharedWorkflowData.workflow_instance.entity_id,
        entity_type: "workflow",
      });
    }
  };

  setSelectedOptions = (selectedOptions, selectedOptionFull) => {
    this.setState({ selectedOptionFull, selectedOptions });
  };

  setAssessmentDetails = (assessmentDetails) => {
    this.setState({ assessmentDetails });
  };

  setNextQuestion = (currentQuestion, isLastQuestion, completionPercentage) => {
    this.setState({
      completionPercentage,
      currentQuestion,
      isLastQuestion,
      selectedOptionFull: [],
      selectedOptions: [],
    });
  };

  optionSelectHandler = (option) => {
    let oldSelectedOptions = this.state.selectedOptions.slice();
    let index = null;
    let foundOption = oldSelectedOptions.find((optionIndex, i) => {
      index = i;

      return optionIndex == option.index;
    });
    let isNoneType = option.type && option.type == "None";
    let isSCQ = this.state.currentQuestion.type == AssessmentQuestionTypeEnum.SINGLE_CHOICE;
    let isLastSelectedNoneType =
      this.state.lastSelectedOption &&
      this.state.lastSelectedOption.type &&
      this.state.lastSelectedOption.type == "None";

    if (isSCQ || isNoneType || isLastSelectedNoneType) {
      foundOption !== undefined ? (oldSelectedOptions = []) : (oldSelectedOptions = [option.index]);
    } else {
      foundOption !== undefined
        ? oldSelectedOptions.splice(index, 1)
        : oldSelectedOptions.push(option.index);
    }
    this.setSelectedOptions(oldSelectedOptions, option);
  };

  getQuestion = (data) => {
    const headers = {
      dob: this.workflowState.dob,
      "X-Entity-Type": this.workflowState.assessment_type,
    };

    workflowRequests
      .get_next_question({ data, headers })
      .then((response) => {
        let data = response;
        let nextQ = data.question;
        let completionPercentage = data.percentage ? Math.ceil(data.percentage) : data.percentage;
        let isLast = (nextQ && nextQ.is_last) || false;

        this.setAssessmentDetails(response["question"]);
        this.setNextQuestion(nextQ, isLast, completionPercentage);
      })
      .catch((error) => {
        captureErrorMessage(parseError({ error, fallback: "Failed to fetch next question" }), {
          tags: {
            component: "AssessmentInProgress",
            errorType: "fetch_question",
            method: "getQuestion",
          },
        });
      });
  };

  submitQuestion = (data) => {
    const headers = {
      dob: this.workflowState.dob,
      "X-Entity-Type": this.workflowState.assessment_type,
    };

    workflowRequests
      .submit_next_question({ data, headers })
      .then((response) => {
        let data = response;
        let nextQ = data.question;
        let completionPercentage = data.percentage ? Math.ceil(data.percentage) : data.percentage;
        let isLast = (nextQ && nextQ.is_last) || false;

        this.setNextQuestion(nextQ, isLast, completionPercentage);
      })
      .catch((error) => {
        captureErrorMessage(parseError({ error, fallback: "Failed to submit question" }), {
          tags: {
            component: "AssessmentInProgress",
            errorType: "submit_question",
            method: "submitQuestion",
          },
        });
      });
  };

  getPrevQuestion = (data) => {
    const headers = {
      dob: this.workflowState.dob,
      "X-Entity-Type": this.workflowState.assessment_type,
    };

    workflowRequests
      .get_last_question({ data, headers })
      .then((response) => {
        let data = response;
        let nextQ = data.question;
        let completionPercentage = data.percentage ? Math.ceil(data.percentage) : data.percentage;
        let isLast = (nextQ && nextQ.is_last) || false;

        this.setNextQuestion(nextQ, isLast, completionPercentage);
      })
      .catch((error) => {
        captureErrorMessage(parseError({ error, fallback: "Failed to fetch previous question" }), {
          tags: {
            component: "AssessmentInProgress",
            errorType: "fetch_prev_question",
            method: "getPrevQuestion",
          },
        });
      });
  };

  render() {
    return (
      <div>
        {this.state.currentQuestion && (
          <Fragment>
            <div className="container">
              <div className="mt-4">
                {this.state.assessmentDetails && (
                  <span>{this.state.assessmentDetails["assessment_type"]} Screening</span>
                )}
              </div>

              <QuestionV2
                classes="col-12 col-lg-6 px-2 px-lg-2 col-lg-4 d-flex py-2 tw:justify-center"
                currentQuestion={this.state.currentQuestion}
                excludeOuterClass={true}
                selectedOptions={this.state.selectedOptions}
                selectOption={(option) => {
                  if (this.state.currentQuestion.type === "single_choice") {
                    this.handleNextQuestion(option);
                  } else {
                    this.optionSelectHandler(option);
                  }
                }}
              />

              <div className="A5ButtonGroup d-flex h-100 align-items-center justify-content-between">
                <Button
                  className="Btn Btn--otl-pri mt-4"
                  onClick={this.handlePrevQuestion}
                  type="button"
                >
                  Previous
                </Button>

                {this.state.currentQuestion.type === "multiple_choice" && (
                  <Button
                    className="Btn Btn--pri mt-4"
                    disabled={this.state.selectedOptions.length === 0 ? "disabled" : null}
                    onClick={() => this.handleNextQuestion()}
                    type="button"
                  >
                    {!this.state.isLastQuestion && "Next"}
                    {this.state.isLastQuestion && "Finish"}
                  </Button>
                )}
              </div>

              <div className="d-flex justify-content-end my-4">
                <div className="col-lg-4 col-12" style={{ padding: 0 }}>
                  <div className="row">
                    <div className="col-lg-12 col-10">
                      <div>
                        <span>
                          <b>{this.state.completionPercentage}% Completed</b>
                        </span>
                      </div>
                      <div className="ProgressBar" style={{ height: 6 }}>
                        <div
                          className="ProgressBar__progress"
                          style={{
                            height: 6,
                            transform: `translate3d(${this.state.completionPercentage + "%"},0,0)`,
                          }}
                        />
                      </div>
                    </div>

                    <div className="d-lg-none col-2">
                      <Button className="scroll-up-btn" onClick={() => window.scrollTo(0, 0)}>
                        <img
                          alt="Scroll Up"
                          className="img-fluid"
                          src={images("./common/chevron.svg")}
                          style={{ transform: "rotate(180deg)" }}
                        />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

export default AssessmentInProgress;
